import { AppRouteProps } from "@harea/component";
import React from "react";

const HeuresSupplementairesCreateContainer = React.lazy(
    () => import("./container/HeuresSupplementairesCreateContainer")
);
const HeuresSupplementairesCreateForm = React.lazy(
    () => import("./container/HeuresSupplementairesCreateForm")
);

export const HeuresSupplementairesCreationRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        title: "std_create_overtime",
        element: <HeuresSupplementairesCreateContainer />,
        children: [
            {
                path: "",
                element: <HeuresSupplementairesCreateForm />,
            }
        ]
    },
    {
        path: ":id/edit",
        title: "std_edit_overtime",
        element: <HeuresSupplementairesCreateContainer />,
        children: [
            {
                path: "",
                element: <HeuresSupplementairesCreateForm />,
            }
        ]
    },
];
